module.exports = __webpack_public_path__ + "static/media/tick-green-thick.bfc166d4.svg";